"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpDefWhoRendererFactory = void 0;
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const Tooltip_1 = __importDefault(require("@opsbase/web-ui/Tooltip"));
const react_1 = __importDefault(require("react"));
const OpDefWhoRendererFactory = () => (item) => {
    if (!item)
        return null;
    const allWho = [...((item === null || item === void 0 ? void 0 : item.positions) || []), ...((item === null || item === void 0 ? void 0 : item.teams) || [])];
    const count = allWho.length;
    // ALL
    if (item === null || item === void 0 ? void 0 : item.allPTsPermitted) {
        return react_1.default.createElement(Text_1.default, null, lib_i18n_1.default.t('anyone'));
    }
    // NONE
    if (!count) {
        return react_1.default.createElement(Text_1.default, null, "- - -");
    }
    // ONE
    if (count === 1) {
        return react_1.default.createElement(Text_1.default, null, allWho[0].title);
    }
    // MANY
    if (count > 1) {
        return (react_1.default.createElement(Tooltip_1.default, { tip: react_1.default.createElement(Vertical_1.default, null, allWho.map((v, idx) => (react_1.default.createElement(Text_1.default, { key: 'tip' + idx }, v.title)))) },
            react_1.default.createElement(Text_1.default, null, allWho[0].title + ' +' + (allWho.length - 1))));
    }
};
exports.OpDefWhoRendererFactory = OpDefWhoRendererFactory;
exports.default = exports.OpDefWhoRendererFactory;
